module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ePcitN/tc-custom/9781948742108.jpg?1732161399946",
      "alt": "This image is the cover for the book Battle of Lincoln Park"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battle of Lincoln Park\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“A brief, cogent analysis of gentrification in Chicago . . . An incisive and useful narrative on the puzzle of urban development” ("), _c('i', [_vm._v("Kirkus")]), _vm._v(").")])]), _c('p', [_vm._v(" In the years after World War II, a movement began to bring the middle class back to the Lincoln Park neighborhood on Chicago's North Side. In place of the old, poorly maintained apartments and dense streetscapes, “rehabbers” imagined a new kind of neighborhood—a modern community that combined the convenience, diversity, and character of a historic urban quarter with the prosperity and privileges of a new subdivision. ")]), _vm._v(" But as property values rose, longtime residents found themselves being evicted to make room for progress—and they began to assert their own ideas about the future of Lincoln Park. As divisions deepened over the course of the 1960s, debate gave way to increasingly violent demonstrations. Each camp became further entrenched as they tried to settle the eternal questions of city planning: Who is a neighborhood for? And who gets to decide? \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel Kay Hertz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Daniel Kay Hertz has written about urban issues for a number of outlets, including City Observatory, The Atlantic, Chicago Magazine, South Side Weekly, and the Chicago Reader. He earned a BA in Government from Harvard University and a")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Belt Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0